import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
import logo from '../../assets/images/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { name: 'Home', to: '/' },
    { name: 'Our Services', to: '/services' },
    { name: 'Import | Export', to: '/import-export' },
    { name: 'Ship Chandlers', to: '/services#chandlery' },
    { name: 'Certifications', to: '/certifications' },
    { name: 'About Us', to: '/about' },
    { name: 'Contact Us', to: '/contact' },
  ];

  const socialLinks = [
    { name: 'Facebook', icon: <FaFacebook size={20} />, url: 'https://facebook.com' },
    { name: 'Twitter', icon: <FaTwitter size={20} />, url: 'https://twitter.com' },
    { name: 'LinkedIn', icon: <FaLinkedin size={20} />, url: 'https://linkedin.com' },
    { name: 'Instagram', icon: <FaInstagram size={20} />, url: 'https://instagram.com' },
  ];

  return (
    <footer className="bg-white border-t border-slate-200/90 pt-14 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-10">
          
          {/* Company Info with Logo - Center on mobile */}
          <div className="text-center md:text-left">
            <Link to="/" className="inline-block mb-4">
              <img src={logo} alt="Infinity Enterprises" className="h-16 w-auto mx-auto md:mx-0" />
            </Link>
            <p className="text-darkGray/70 text-sm mb-4 max-w-xs mx-auto md:mx-0">
              Leading logistics and maritime company specializing in reliable shipping solutions for global trade.
            </p>
            {/* Social Media Icons - Center on mobile */}
            <div className="flex space-x-3 justify-center md:justify-start">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-100 hover:bg-teal hover:text-white p-2 rounded-full transition-colors duration-200 text-darkGray"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links - Center on mobile */}
          <div className="text-center md:text-left">
            <h4 className="font-semibold text-base uppercase tracking-wide text-navy mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.to} className="text-darkGray/75 hover:text-teal transition-colors text-sm inline-block py-0.5">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services - Center on mobile */}
          <div className="text-center md:text-left">
            <h4 className="font-semibold text-base uppercase tracking-wide text-navy mb-4">Our Services</h4>
            <ul className="space-y-2.5">
              <li><Link to="/services" className="text-darkGray/75 hover:text-teal transition-colors text-sm">Ship Stores Supply</Link></li>
              <li><Link to="/services" className="text-darkGray/75 hover:text-teal transition-colors text-sm">Provision Stores</Link></li>
              <li><Link to="/services" className="text-darkGray/75 hover:text-teal transition-colors text-sm">Safety Equipment</Link></li>
              <li><Link to="/services" className="text-darkGray/75 hover:text-teal transition-colors text-sm">Marine Chemicals</Link></li>
              <li><Link to="/import-export" className="text-darkGray/75 hover:text-teal transition-colors text-sm">Export Division</Link></li>
            </ul>
          </div>

          {/* Contact Info - Center on mobile */}
          <div className="text-center md:text-left">
            <h4 className="font-semibold text-base uppercase tracking-wide text-navy mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-center justify-center md:justify-start gap-2 text-sm text-darkGray/70">
                <MapPin size={18} className="text-teal flex-shrink-0" />
                <span>Shop no 30, Dimple Arcade,  Thakur Complex,  Kandivali East,  Mumbai 400101</span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-2 text-sm text-darkGray/70">
                <Phone size={18} className="text-teal" />
                <span>+91 9594184195,+91 8637730449</span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-2 text-sm text-darkGray/70">
                <Mail size={18} className="text-teal" />
                <span>info@infinityenterprises.in</span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-2 text-sm text-darkGray/70">
                <Clock size={18} className="text-teal" />
                <span>24/7 Support Available</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar - Center on mobile */}
        <div className="border-t border-slate-200/90 pt-8 text-center">
          <p className="text-darkGray/55 text-sm">
            &copy; {currentYear} Infinity Enterprises. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;